var path = 'messages/start.html';
var html = "<div class=\"box-rightWrap messages-start\"> <div class=messages-start-content> <h1 class=h1-noMarginTop data-i18n=messages.start.header></h1> <h3 class=h1-noMarginTop data-i18n=messages.start.info></h3> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/messages/start.html
// module id = zOIU
// module chunks = 1